module.exports = __webpack_public_path__ + "img/middle.c24097eb.jpg";